import { fetchWithAuth } from "./fetchWithAuth";
import { withApiKeyHeaders } from "./apiKeyFetch";

const API_BASE = process.env.REACT_APP_API_BASE;
const PAYMENTS_BASE = `${API_BASE}/api/v1/payments`;

const asError = async (response, fallbackMessage) => {
  if (!response) {
    throw new Error(fallbackMessage);
  }
  const text = await response.text().catch(() => "");
  throw new Error(text || fallbackMessage);
};

export async function createReactCheckout({
  productId,
  variantId,
  email,
  redirectUrl,
}) {
  const payload = {
    product_id: productId,
    email,
    redirect_url: redirectUrl,
  };

  if (variantId !== undefined && variantId !== null && variantId !== "") {
    payload.variant_id = variantId;
  }

  const response = await fetchWithAuth(`${PAYMENTS_BASE}/checkouts`, {
    method: "POST",
    body: JSON.stringify(payload),
  });

  if (!response || !response.ok) {
    await asError(response, "Неуспешно креирање на checkout.");
  }

  return response.json();
}

export async function getReactCheckoutStatus(purchaseReference) {
  const reference = encodeURIComponent(String(purchaseReference || ""));
  const response = await fetchWithAuth(
    `${PAYMENTS_BASE}/checkouts/${reference}/status`,
    { method: "GET" }
  );

  if (!response || !response.ok) {
    await asError(response, "Неуспешно вчитување на статус.");
  }

  return response.json();
}

export async function getMyEntitlements() {
  const response = await fetchWithAuth(`${PAYMENTS_BASE}/me/entitlements`, {
    method: "GET",
  });

  if (!response || !response.ok) {
    await asError(response, "Неуспешно вчитување на entitlements.");
  }

  return response.json();
}

export async function getPaymentsConfig() {
  const url = `${PAYMENTS_BASE}/config`;
  const response = await fetch(url, {
    method: "GET",
    headers: withApiKeyHeaders(url, {
      "Content-Type": "application/json",
    }),
  });

  if (!response.ok) {
    await asError(response, "Неуспешно вчитување на payments config.");
  }

  return response.json();
}
